export interface StrategyItem {
  id: string;
  name: string;
  author: string;
  avatar: string;
  flag: string;
  country: string;
  platform: 'MT4' | 'MT5' | 'cTrader';
  rating: number;
  reviewsCount: number;
  growth: number;
  sinceYear: number;
  reliabilityBars: number; // 1 to 5
  algoPercent: number;
  algoBars: number; // 1 to 5
  copiersCount: number | string;
  copyPrice: number;
  pathD: string;
  areaD: string;
}

export const STRATEGIES_DATA: StrategyItem[] = [
  // MT4 Strategies
  {
    id: 'mt4-1',
    name: 'Precise Pair Trading Pro',
    author: 'Arkadii Zagorulko',
    avatar: 'https://i.pravatar.cc/150?img=53',
    flag: 'https://flagcdn.com/w20/ie.png',
    country: 'Ireland',
    platform: 'MT4',
    rating: 2.96,
    reviewsCount: 9,
    growth: 471,
    sinceYear: 2025,
    reliabilityBars: 4,
    algoPercent: 98,
    algoBars: 4,
    copiersCount: 19,
    copyPrice: 50,
    pathD: 'M0,35 C10,35 25,35 35,34 C45,34 50,28 55,25 C65,18 70,18 75,15 C85,15 90,8 95,7 C98,6 99,5 100,4',
    areaD: 'M0,35 C10,35 25,35 35,34 C45,34 50,28 55,25 C65,18 70,18 75,15 C85,15 90,8 95,7 C98,6 99,5 100,4 L100,40 L0,40 Z',
  },
  {
    id: 'mt4-2',
    name: 'GBP Focus Swing',
    author: 'Sarah Jenkins',
    avatar: 'https://i.pravatar.cc/150?img=12',
    flag: 'https://flagcdn.com/w20/gb.png',
    country: 'UK',
    platform: 'MT4',
    rating: 4.10,
    reviewsCount: 84,
    growth: 125,
    sinceYear: 2025,
    reliabilityBars: 3,
    algoPercent: 60,
    algoBars: 3,
    copiersCount: 312,
    copyPrice: 25,
    pathD: 'M0,35 C20,34 30,32 40,28 C50,24 60,25 70,20 C80,15 90,12 100,8',
    areaD: 'M0,35 C20,34 30,32 40,28 C50,24 60,25 70,20 C80,15 90,12 100,8 L100,40 L0,40 Z',
  },
  {
    id: 'mt4-3',
    name: 'Asian Session Scalper',
    author: 'Li Wei',
    avatar: 'https://i.pravatar.cc/150?img=15',
    flag: 'https://flagcdn.com/w20/cn.png',
    country: 'China',
    platform: 'MT4',
    rating: 4.88,
    reviewsCount: 412,
    growth: 210,
    sinceYear: 2024,
    reliabilityBars: 5,
    algoPercent: 85,
    algoBars: 4,
    copiersCount: 540,
    copyPrice: 40,
    pathD: 'M0,35 C15,36 30,32 40,28 C50,24 55,20 65,15 C75,10 85,12 100,5',
    areaD: 'M0,35 C15,36 30,32 40,28 C50,24 55,20 65,15 C75,10 85,12 100,5 L100,40 L0,40 Z',
  },

  // MT5 Strategies
  {
    id: 'mt5-1',
    name: 'Gold Reaper New V2 2',
    author: 'Wim Schrynemakers',
    avatar: 'https://i.pravatar.cc/150?img=11',
    flag: 'https://flagcdn.com/w20/be.png',
    country: 'Belgium',
    platform: 'MT5',
    rating: 2.69,
    reviewsCount: 12,
    growth: 302,
    sinceYear: 2024,
    reliabilityBars: 4,
    algoPercent: 99,
    algoBars: 5,
    copiersCount: 37,
    copyPrice: 35,
    pathD: 'M0,32 C15,31 25,31 35,29 C45,26 50,23 60,20 C70,16 75,13 85,9 C90,7 95,6 100,5',
    areaD: 'M0,32 C15,31 25,31 35,29 C45,26 50,23 60,20 C70,16 75,13 85,9 C90,7 95,6 100,5 L100,40 L0,40 Z',
  },
  {
    id: 'mt5-2',
    name: 'JPY Hedging Master',
    author: 'Kenji Tanaka',
    avatar: 'https://i.pravatar.cc/150?img=32',
    flag: 'https://flagcdn.com/w20/jp.png',
    country: 'Japan',
    platform: 'MT5',
    rating: 4.95,
    reviewsCount: 520,
    growth: 610,
    sinceYear: 2022,
    reliabilityBars: 5,
    algoPercent: 100,
    algoBars: 5,
    copiersCount: '3,402',
    copyPrice: 200,
    pathD: 'M0,38 C15,38 30,36 40,30 C50,24 55,20 65,18 C75,16 85,10 100,2',
    areaD: 'M0,38 C15,38 30,36 40,30 C50,24 55,20 65,18 C75,16 85,10 100,2 L100,40 L0,40 Z',
  },
  {
    id: 'mt5-3',
    name: 'Crypto Trend Follower',
    author: 'Alexey Ivanov',
    avatar: 'https://i.pravatar.cc/150?img=60',
    flag: 'https://flagcdn.com/w20/ru.png',
    country: 'Russia',
    platform: 'MT5',
    rating: 4.20,
    reviewsCount: 110,
    growth: 450,
    sinceYear: 2023,
    reliabilityBars: 3,
    algoPercent: 80,
    algoBars: 4,
    copiersCount: 890,
    copyPrice: 80,
    pathD: 'M0,32 C10,34 20,28 30,26 C40,24 50,15 60,12 C70,10 80,6 100,2',
    areaD: 'M0,32 C10,34 20,28 30,26 C40,24 50,15 60,12 C70,10 80,6 100,2 L100,40 L0,40 Z',
  },

  // cTrader Strategies
  {
    id: 'ctrader-1',
    name: 'AI Scalper System USD',
    author: 'John Doe',
    avatar: 'https://i.pravatar.cc/150?img=68',
    flag: 'https://flagcdn.com/w20/us.png',
    country: 'USA',
    platform: 'cTrader',
    rating: 4.50,
    reviewsCount: 156,
    growth: 850,
    sinceYear: 2023,
    reliabilityBars: 3,
    algoPercent: 80,
    algoBars: 4,
    copiersCount: '1,204',
    copyPrice: 100,
    pathD: 'M0,38 C15,36 25,35 35,28 C45,22 50,18 60,15 C70,12 80,8 100,4',
    areaD: 'M0,38 C15,36 25,35 35,28 C45,22 50,18 60,15 C70,12 80,8 100,4 L100,40 L0,40 Z',
  },
  {
    id: 'ctrader-2',
    name: 'Commodity Trend Follow',
    author: "Liam O'Connor",
    avatar: 'https://i.pravatar.cc/150?img=5',
    flag: 'https://flagcdn.com/w20/au.png',
    country: 'Australia',
    platform: 'cTrader',
    rating: 3.50,
    reviewsCount: 22,
    growth: 188,
    sinceYear: 2024,
    reliabilityBars: 2,
    algoPercent: 40,
    algoBars: 2,
    copiersCount: 89,
    copyPrice: 15,
    pathD: 'M0,32 C10,34 20,35 30,30 C40,25 50,15 60,18 C70,21 80,12 100,5',
    areaD: 'M0,32 C10,34 20,35 30,30 C40,25 50,15 60,18 C70,21 80,12 100,5 L100,40 L0,40 Z',
  },
  {
    id: 'ctrader-3',
    name: 'EUR/USD Volatility Breakout',
    author: 'Maria Garcia',
    avatar: 'https://i.pravatar.cc/150?img=43',
    flag: 'https://flagcdn.com/w20/es.png',
    country: 'Spain',
    platform: 'cTrader',
    rating: 3.90,
    reviewsCount: 77,
    growth: 340,
    sinceYear: 2024,
    reliabilityBars: 4,
    algoPercent: 75,
    algoBars: 4,
    copiersCount: 215,
    copyPrice: 20,
    pathD: 'M0,36 C10,36 20,32 30,30 C40,28 50,22 60,18 C70,14 80,10 100,5',
    areaD: 'M0,36 C10,36 20,32 30,30 C40,28 50,22 60,18 C70,14 80,10 100,5 L100,40 L0,40 Z',
  },
];
